import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from './Skeleton';
import 'react-toastify/dist/ReactToastify.css';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapReactToast = React.lazy(function () {
    return import('../../bootstrap-components/components/BTReactToast');
});
var bootStrapReactToast = function (props) {
    return (React.createElement(BootStrapReactToast, __assign({}, props)));
};
var ReactToast = function (props) {
    var componentToDisplay = bootStrapReactToast(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapReactToast(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
export default ReactToast;
//# sourceMappingURL=ReactToast.js.map